import { useTranslation } from "react-i18next";
import { Scaffold } from "../shell/Scaffold";
import { Navbar } from "../shell/Navbar";
import { Display } from "@acdc2/ui/components/access-typography";

export function HelpScreen() {
  const { t } = useTranslation();

  return (
    <Scaffold navbar={<Navbar />}>
      <div className="p-8">
        <Display asChild>
          <h1>{t("HelpScreen.title")}</h1>
        </Display>
      </div>
    </Scaffold>
  );
}
